module.exports = __webpack_public_path__ + "static/media/seniors.1011fd09.jpg";